import { StateCreator } from 'zustand';
import { Coordinate } from 'ol/coordinate';
import { IAppStore } from '../../../IAppStore';
import IdentifySlice, { IdentifySliceProps } from './IdentifySlice';
import {
  DefaultResultProperties,
  IdentifyLegendProps,
  LandownerNavigation,
} from '../api/contract';
import { Eigentuemer } from '../api/useLandowners';

export const defaultIdentifyProps: IdentifySliceProps = {
  defaultResultProperties: null,
  showidentifyOverlay: false,
  tolerance: 50,
  showLegend: false,
  identifyLegend: {
    topicLayerId: '',
    layerId: -1,
    title: '',
  },
  identifyCoordinate: null,
  landownerEigentuemer: null,
  landownerNavigation: [],
};

const createIdentifySlice: StateCreator<IAppStore, [], [], IdentifySlice> = (set) => ({
  ...defaultIdentifyProps,
  setIdentifyDefaultResultProperties: (
    defaultResultProperties: DefaultResultProperties,
  ) => set({ defaultResultProperties }),
  setTolerance: (tolerance: number) => set({ tolerance }),
  setShowLegend: (showLegend: boolean) => set({ showLegend }),
  setIdentifyLegend: (identifyLegend: IdentifyLegendProps) => set({ identifyLegend }),
  setIdentifyCoordinate: (identifyCoordinate: Coordinate | null) =>
    set({ identifyCoordinate }),
  setLandownerEigentuemer: (landownerEigentuemer: Eigentuemer[]) =>
    set({ landownerEigentuemer }),
  setLandownerNavigation: (landownerNavigation: LandownerNavigation[]) =>
    set({ landownerNavigation }),
});

export default createIdentifySlice;
